import { ReactElement } from 'react';
import { IntlShape } from 'react-intl';

export const dictionary = {
    loginwall_title: (intl: IntlShape, { br }: { br: ReactElement }) =>
        intl.formatMessage(
            {
                id: 'allplay.paywall_fallback_title',
                defaultMessage:
                    'Streaming services{br}and TV channels catalog{br}all in one subscription',
                description: 'Текст на пэйволле/логинволе по умолчанию. {br} - перенос строки',
            },
            { br }
        ),
    loginwall_subtitle: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'allplay.loginwall_subtitle',
            defaultMessage: 'A massive library is waiting — full seasons and exclusive films',
            description: 'Подзаголовок на логинволе по умолчанию',
        }),
    loginwall_button: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'allplay.loginwall_button',
            defaultMessage: 'Get started',
            description: 'Текст кнопки входа в профиль на логинволе',
        }),
    paywall_title: (intl: IntlShape, { br }: { br: ReactElement }) =>
        intl.formatMessage(
            {
                id: 'allplay.paywall_fallback_title',
                defaultMessage:
                    'Streaming services{br}and TV channels catalog{br}all in one subscription',
                description: 'Текст на пэйволле/логинволе по умолчанию. {br} - перенос строки',
            },
            { br }
        ),
    paywall_subtitle: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'allplay.paywall_subtitle',
            defaultMessage: 'Enjoy blockbusters and hit series',
            description: 'Подзаголовок пэйволла на главной',
        }),
    multi_paywall_title: (intl: IntlShape, { br }: { br: ReactElement }) =>
        intl.formatMessage(
            {
                id: 'allplay.paywall_fallback_title',
                defaultMessage:
                    'Streaming services{br}and TV channels catalog{br}all in one subscription',
                description: 'Текст на пэйволле/логинволе по умолчанию. {br} - перенос строки',
            },
            { br }
        ),
    fallback_title: (intl: IntlShape, { br }: { br: ReactElement }) =>
        intl.formatMessage(
            {
                id: 'allplay.paywall_fallback_title',
                defaultMessage:
                    'Streaming services{br}and TV channels catalog{br}all in one subscription',
                description: 'Текст на пэйволле/логинволе по умолчанию. {br} - перенос строки',
            },
            { br }
        ),
    onboarding__arrow_button_text: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'components.ArrowBottom.f6f90bb01c475e0166eb29df1f498079',

            defaultMessage: 'Learn more about the subscription',
            description: 'Заголовок кнопки "Подробнее о подписке"',
        }),
    subscription_offer_button_get_started: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'components.ChannelsPage.be11c74c1dd7f307bb80183a90dc2067',
            defaultMessage: 'Get started',
            description: 'Текст кнопки оффера при включенном логинволе',
        }),
    subscription_offer_button_subscribe: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.offer-button.dfa592421ec2584a960f077610eb19bd',
            defaultMessage: 'Subscribe now',
            description: 'Текст кнопки оформления подписки',
        }),
    range_email_notification: (intl: IntlShape, { days }: { days: number }) =>
        intl.formatMessage(
            {
                id: 'common.ott.components.Range.a42ad420d2c5a1944de471da66194c85',
                defaultMessage:
                    "We'll send a message to your email {days, plural, one {# day} few {# days} other {# days}} in advance",
                description: 'Текст описания услуги отправки письма на почту',
            },
            { days }
        ),
    currencyCode: (intl: IntlShape, { currency }: { currency: string | undefined }) =>
        intl.formatMessage(
            {
                id: 'pages.main.ui.multi-offer-plans.88db996e142302421d01513f9bb29edd',
                defaultMessage: '{currency, select, undefined {} UZS {UZS} other {}}',
                description: 'Валюта',
            },
            {
                currency,
            }
        ),
    subscriptionPeriod: (intl: IntlShape, { period }: { period: string | undefined }) =>
        intl.formatMessage(
            {
                id: 'pages.main.ui.multi-offer-plans.6406859db98fbd91ff337d187ec17cca',
                defaultMessage:
                    '{period, select, undefined {} P1M {month} P1MT1S {month} P30D {month} P31D {month} P1Y {year} P360D {year} other {}}',
                description: 'Период действия подписки',
            },
            {
                period,
            }
        ),
    popular_badge: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.onboarding.2cc1943d4c0b46bfcf503a75c44f988b',
            defaultMessage: 'Popular',
            description: 'Бейджик для популярного оффера',
        }),
};
